import { Injector } from "@angular/core";
import { BaseNode } from "../../BaseNode";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { MedicinalDeviceEntity } from "../../../Data/MedicinalProductData/MedicinalDeviceEntity";
import { environment } from "../../../../../../environments/environment";

export class TreeNodeMedicinalDeviceEntity extends BaseNode {

    constructor(injector: Injector, model: any, parent:any) {

        super(injector, 
            new MedicinalDeviceEntity(injector, model),
            model.medicaldevicecode.name);

        this.parent=parent;
        this.ioc!.get(Art57Section).generateNumColumValue(this);

    }
    public getListItem(): any[] {
        return [this.data.model.medicaldevicecode.name];
    }

    override cloneNode(newParent: BaseNode): BaseNode {
      let clonedNode: TreeNodeMedicinalDeviceEntity = new TreeNodeMedicinalDeviceEntity(this.ioc!,this.data.model, newParent);      

      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));

      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

// property diesn't exist      clonedNode.cloningNode = false;
      return clonedNode;
    }


}